<template>
  <span>
    <select v-if="displayType === 'form'" name="" class="form-control" v-bind:value="value"
            v-on:change="onChange($event.target.value)">
      <slot></slot>
      <option v-for="sportRegion in sportRegionList" :value="sportRegion.value"
              :selected="sportRegion.value == defaultSportRegion">
        {{sportRegion.label}}
      </option>
    </select>
    <span v-if="displayType === 'label'">{{sportRegionLabel}}</span>
  </span>
</template>

<script>
  import CommonDataService from '../endpoints/CommonDataService'
  import { clone } from 'lodash'

  export default {
    model: {
      prop: 'value',
      event: 'change'
    },
    name: 'sport-region-input',
    props: {
      value: {},
      displayType: {
        type: String,
        default: 'form'
      },
      orgSport: Object
    },
    data () {
      return {
        sportRegionList: [],
        oldOrgSport: {
          sportCode: '',
          division: '',
          subdivision: ''
        }
      }
    },
    computed: {
      defaultSportRegion () {
        return this.value
      },
      sportRegionLabel: function () {
        if (this.sportRegionList && this.sportRegionList.length > 0) {
          let sportRegion = this.sportRegionList.find((el) => el.value === this.value)
          if (sportRegion) return sportRegion.label
        }

        return ''
      }
    },
    watch: {
      orgSport: {
        handler (val) {
          if (val.sportCode !== this.oldOrgSport.sportCode ||
            val.division !== this.oldOrgSport.division ||
            val.subdivision !== this.oldOrgSport.subdivision) {
            this.loadSportRegionList()
          }
        },
        deep: true
      }
    },
    methods: {
      loadSportRegionList: function () {
        let self = this
        if (this.orgSport.sportCode && this.orgSport.academicYear && this.orgSport.division) {
          this.oldOrgSport = clone(this.orgSport)
          CommonDataService.loadSportRegionList(this.orgSport.sportCode, this.orgSport.academicYear, this.orgSport.division, this.orgSport.subdivision)
            .then(response => {
              self.sportRegionList = response.data
            })
            .catch(error => {
              self.error = error.message
            })
        }
      },
      onChange (value) {
        this.$emit('change', value)
      }
    },
    created () {
      this.loadSportRegionList()
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/SportRegionLovComponent.vue